export default __webpack_public_path__ + "static/media/The End of Kings.f2956b27.jpg";